import React, { useEffect, useImperativeHandle } from 'react';
import './Tab.scss';

const Tab = ({routes, renderItems, containerStyle, onTabChange, headerStyle, current }) => {
    const [ currentRoute, setCurrentRotue ] = React.useState(routes[0].route)

    
    return(
        <div>
            <div className='tab' style={ headerStyle }>
                {
                    routes.map((data,i) => {
                        return(
                            <p className={`tab-header ${ data.route === current ? 'active' : ''}`} onClick={() => {setCurrentRotue(data.route);onTabChange(data.route)}} key={data.route} style={ i + 1 === routes.length  ? { marginRight : 0} : {}}>{data.header}</p>
                        )
                    })
                }
                <div className='line' />
            </div>
            <div className='container' style={ containerStyle }>
                {
                    renderItems[currentRoute]
                }
            </div>
        </div>
    )
}

export default Tab;